// Shared row formatter for the thermal "Product Sold" report.
// Used by all 3 print paths (Dashboard Actions, Close Shop, v2/reports Print Terminal)
// so the on-paper output stays consistent.

export type ProductSoldSubRow = {
  subName: string
  qty: number
  amount: number
}

export type ProductSoldItemRow = {
  itemName: string
  subItems: ProductSoldSubRow[]
}

export type ThermalCommand = { name: string; value: string }

const isRegular = (s: string) => s.trim().toLowerCase() === 'regular'

// Hide "(subName)" ONLY when the item has exactly one sub AND that sub is literally
// named "Regular" (case-insensitive). Multiple subs, or a single sub with a real name,
// always print the parenthetical so distinct SKUs remain distinguishable on the receipt.
export function buildProductSoldItemRows(
  item: ProductSoldItemRow,
  formatMoney: (n: number) => string,
): ThermalCommand[] {
  const realSubs = (item.subItems || []).filter((s) => Number(s.qty) > 0)
  if (!realSubs.length) return []

  const onlySub = realSubs.length === 1 ? realSubs[0] : null
  const hideSubLabel = !!onlySub && isRegular(onlySub.subName || '')

  return realSubs.map((sub) => {
    const label = hideSubLabel
      ? `${sub.qty} ${item.itemName}`
      : `${sub.qty} ${item.itemName} (${sub.subName})`
    return { name: label, value: formatMoney(sub.amount) }
  })
}
